<header class="header" [ngClass]="{ 'removed-header-background': !(globalService.showSidebar | async) }">
    <div class="header-left">
        <button
            *ngIf="globalService.showSidebar | async"
            class="menu-btn"
            (keydown.enter)="$event.preventDefault()"
            (click)="toggleSidebarForOpen()"
        >
            ☰
        </button>
        <!-- <div *ngIf="!(globalService.showSidebar | async) && !isMobile" class="logo" [routerLink]="'/loan/apply'">
            <img src="assets/svg/icons/brand-logo.svg" alt="Klinq logo" />
        </div> -->
        <h3 class="greeting">{{ customerName }}</h3>
    </div>
    <div class="header-right">
        <div
            class="header-right-reward"
            *ngIf="globalService.rewardWalletBalance | async as count"
            [routerLink]="['/reward-wallet']"
        >
            <button type="button" (keydown.enter)="$event.preventDefault()" class="header-right-reward-btn">
                <img class="header-right-reward-btn-icon" src="assets/svg/icons/brand-icon-fill.svg" alt="icon" />
                <h3 class="header-right-reward-btn-count">{{ count }}</h3>
            </button>
        </div>
        <button
            type="button"
            (keydown.enter)="$event.preventDefault()"
            class="header-right-notification-btn"
            [routerLink]="['/notifications']"
        >
            <img src="assets/svg/icons/bell.svg" alt="Notifications" />
            <ng-container *ngIf="globalService.unreadNotificationsCount | async as count">
                <span class="badge" *ngIf="count > 0"></span>
            </ng-container>
            <!-- <span class="badge" *ngIf="(globalService.unreadNotificationsCount | async) > 0">{{(globalService.unreadNotificationsCount | async)}}</span> -->
        </button>
    </div>
</header>
